import SecurityGate from './security/SecurityGate';
import * as components from '@sinohealth/butterfly-formily-components';
import '@sinohealth/butterfly-formily-components/lib/index.css';
import { registerComponents, registerScope } from '@sinohealth/butterfly-formily-engine';
import styles from './App.less';
import { appName, baseURL, isDev, scope } from './config/base';
import RenderRoutes from './router/router';
import { getLocalStorage, getToken, TOKEN_KEY } from './utils/cookies';

const pathname = window.location.pathname.replace(/\//g, '');

console.log({
  authorization: getToken() || getLocalStorage(TOKEN_KEY),
  baseUrl: isDev ? baseURL : `${window.location.origin}${pathname ? `/${pathname}` : ''}`,
  scope,
  app: appName,
});

registerScope({
  authorization: getToken() || getLocalStorage(TOKEN_KEY),
  baseUrl: isDev ? baseURL : `${window.location.origin}${pathname ? `/${pathname}` : ''}`,
  scope,
  app: appName,
});

registerComponents({ ...components, FormProvider: components.Form });

(global as any).config = { app: 'sdc-hccm-hosp', clientPrefix: '/hospital' };

function App() {
  return (
    <div className={styles.app}>
      <SecurityGate>
        <RenderRoutes />
      </SecurityGate>
    </div>
  );
}

export default App;
